import { Expandable } from './../../js/Expandable'

import './index.scss'

class FilteredGrid {
    constructor(el) {
        this.$el = el

        // console.log('FilteredGrid::constructor')
    }
    init() {
        const $filters = this.$el.querySelector('#filters')
        if (!$filters) return
        
        // else
        this.filtersExpandable = new Expandable($filters)
        
        this.desktopDisplayQuery = window.matchMedia('(min-width: 1161px)') // while the media query is true, menu is displayed as mobile

        // set listener...
        this.desktopDisplayQuery.addEventListener('change', this.onDesktopDisplayQueryChange.bind(this), {capture: false, passive: true, once: false} || false)
        // ...then trigger it once
        this.onDesktopDisplayQueryChange(this.desktopDisplayQuery)
    }
    onDesktopDisplayQueryChange(e) {
        if (e.matches === false) { // mobile
            // console.log('mobile')
            this.filtersExpandable.enable()
            this.filtersExpandable.close()
        } else { //desktop
            // console.log('desktop')
            this.filtersExpandable.open()
            this.filtersExpandable.disable()
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('.oce-filtered-grid')).forEach($block => {
        $block.expandygg = new FilteredGrid($block)
    })
}, {capture: false, passive: true, once: true} || false)